import React, { useEffect, useState } from "react";
import "./AwardsScroller.css"; 

const AwardsScroller = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);




  const images = [
    { id: 1, src: "awards/eGov.jpg", alt: "eGov" },
    { id: 2, src: "awards/Skochorder-2015.png", alt: "Skochorder" },
    { id: 3, src: "awards/Award of Excellence.png", alt: "Award of Excellence" },
    { id: 4, src: "awards/e-Governance.png", alt: "e-Governance.png" },
    { id: 5, src: "awards/CSI.png", alt: "CSI" },
    { id: 6, src: "awards/Skochorder-2016.png", alt: "Skochorder-2016" },
    { id: 7, src: "awards/NIC.png", alt: "NIC.png" },
    { id: 8, src: "awards/MobileApp.png", alt: "MobileApp.png" },
    // {id: 9, src:"https://epos.jk.gov.in/links/nic_logo.png" , alt:""},
    // {id:10, src:"https://epos.jk.gov.in/links/india-gov.png" , alt:""},
    // {id:11, src:"https://epos.jk.gov.in/links/fooddistribution.png", alt:""},
    // {id:12, src:"https://epos.jk.gov.in/links/dgindiasmall.png",alt:""},
    // {id:13, src:"https://epos.jk.gov.in/links/gov.gif"},
    // {id:14,src:"https://epos.jk.gov.in/links/FCI.gif"},
    // {id:15,src:"https://epos.jk.gov.in/links/e-portal.gif"},
  ];

  const duplicated = [...images, ...images];

  return (
    <div className="awards-section">
      <div className="awards-container">
        <div className="section-header">
          <h2>Awards and Recognization</h2>
          <p>Honored for excellence, innovation, and impactful achievements in our field</p>
        </div>

        <div className="scroller-wrapper">
          <div className="fade-left"></div>
          <div className="fade-right"></div>

          <div className="scroller-track">
            
             {(isMobile ? images :  duplicated).map((img, idx) => (
              <div className="award-card" key={`${img.id}-${idx}`}>
                <img src={img.src} alt={img.alt} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AwardsScroller;
